var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopFondoLandingSinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1587,
    height: 890,
    viewBox: "0 0 1587 890",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1587,
    height: 890,
    fill: "none",
    stroke: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(12627 8428.7) rotate(3)",
    d: "m-13054-7756.2s12.372 69.455 67.1 68.628 64.941-75.382 138.08-68.628 86 101.05 154.49 95.643 37.39-91.4 100.09-121.86 62.362 17.9 151.61 12.506 83.621-60.957 179.31-64.083 117.82 48.15 203.43 51.577 107.1-48.152 155.7-21.577 58.589 89.308 127.54 89.958 75.827-56.7 133.66-68.38 69.923 0.027 114.09 0 69.966-21.577 69.966-21.577l-2.83-54-1584.6 24z",
    fill: "#f2f0ea",
    opacity: 0.852
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.31 -1427.6)",
    fill: "none",
    stroke: "#dfded2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    transform: "translate(1082.7 1725.4)",
    x2: 17.45
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1091.4 1716.7)",
    y1: 17.45
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1085.5 1719)",
    x2: 11.884,
    y2: 12.778
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1085 1719.4)",
    x2: 12.778,
    y1: 11.884
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-922.63 -1185.7)",
    fill: "none",
    stroke: "#ece9e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    transform: "translate(1082.7 1727.2)",
    x2: 21
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1093.2 1716.7)",
    y1: 21
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1086 1719.5)",
    x2: 14.301,
    y2: 15.378
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1085.5 1720)",
    x2: 15.378,
    y1: 14.301
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.76 -890.11)",
    fill: "none",
    stroke: "#ece9e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    transform: "translate(1082.7 1721.8)",
    x2: 10.231
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1087.8 1716.7)",
    y1: 10.231
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1084.3 1718)",
    x2: 6.967,
    y2: 7.492
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1084.1 1718.3)",
    x2: 7.492,
    y1: 6.967
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-608.24 -1656.3)",
    fill: "none",
    stroke: "#ece9e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    transform: "translate(1082.7 1721.8)",
    x2: 10.231
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1087.8 1716.7)",
    y1: 10.231
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1084.3 1718)",
    x2: 6.967,
    y2: 7.492
  }), /*#__PURE__*/React.createElement("line", {
    transform: "translate(1084.1 1718.3)",
    x2: 7.492,
    y1: 6.967
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopFondoLandingSinLogo);
export default __webpack_public_path__ + "static/media/desktop_fondo_landing_sin_logo.aa9d494e328c708eb41c18c97ae7843b.svg";
export { ForwardRef as ReactComponent };